import TeX from "@matejmazur/react-katex";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import FormulaIcon from "./Icons/FormulaIcon";
import InfoIcon from "./Icons/InfoIcon";

export const IconType = Object.freeze({
  INFO: 0,
  FORMULA: 1,
});

// react-katex
// https://github.com/MatejBransky/react-katex

function ToolTip({ text, id, formula, type = 0 }) {
  return (
    <>
      <span data-tooltip-id={id} className="input--formula">
        {type === IconType.INFO ? <InfoIcon /> : null}
        {type === IconType.FORMULA ? <FormulaIcon /> : null}
      </span>
      <Tooltip
        id={id}
        className="formulaTooltip"
        border="1px solid #0080c5"
        place="right"
        // Position relative to the viewport (not the document) so the tooltip
        // never expands the page and triggers a scrollbar, which otherwise
        // shifts the whole layout on hover (visible in Chrome's classic
        // width-taking scrollbars; invisible with Firefox overlay scrollbars).
        positionStrategy="fixed"
        closeDelay={1000}
        style={{ backgroundColor: "white", color: "#5F4B8BFF" }}
      >
        {type === IconType.INFO ? <span>{text}</span> : null}
        {type === IconType.FORMULA ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 10px",
              fontSize: "1.15rem",
              lineHeight: 1.3,
            }}
          >
            <TeX>{formula}</TeX>
          </div>
        ) : null}
      </Tooltip>
    </>
  );
}

export default ToolTip;
